<template>
  <!-- 아래 요소 높이 일정해야 함 -->
  <div>
    <div class="payment__content" v-if="orderSavingYn == true">
      <!-- header -->
      <div class="payment__header">
        <div class="lyr-title">{{ $t('User.OrderSaving.msg1') }}</div>
        <div class="ft-point">{{ $t('User.OrderSaving.msg2') }}</div>
        <div class="lyr-txt">{{ $t('User.OrderSaving.msg3') }}</div>
      </div>
      <!-- //header -->
      <div class="payment__body">
        <div class="lst-order lst--xlg">
          <dl>
            <dt class="order-check">{{ $t('User.OrderSaving.msg15') }}</dt>
            <dd class="order-check">{{ baskets.HEADER.ORDER_QTY }}</dd>
          </dl>
          <dl>
            <dt class="order-check">{{ $t('User.OrderSaving.msg16') }}</dt>
            <dd class="order-check">{{ $displayUprc(baskets.HEADER.TOT_DC_AMT) }}</dd>
          </dl>
          <dl>
            <dt class="order-check">{{ $t('User.OrderSaving.msg17') }}</dt>
            <dd class="order-check">{{ $displayUprc(baskets.HEADER.PAID_AMT) }}</dd>
          </dl>
          <dl>
            <dt class="order-check">{{ $t('User.OrderSaving.msg18') }}</dt>
            <dd class="ft--3xlg ft--point">{{ $displayUprc(baskets.HEADER.SALES_AMT) }}</dd>
          </dl>
        </div>
        <div class="lst-box">
          <!-- one item -->
          <!-- 멤버쉽 -->
          <div v-if="useMembership || useCoupon" class="touchbox touchbox--port btn-anim" :class="{on: savingList.indexOf(1) != -1}" @mouseup="membersOn()">
            <span class="ico-checked">checked</span>
            <img src="@/assets/images/user/img_master_membership.png" alt="" />
            <span class="txt">{{ $t('User.OrderSaving.msg4') }}</span>
          </div>

          <!-- 스탬프(미사용) -->
          <div
            v-if="useStamp"
            class="touchbox touchbox--port btn-anim"
            style="display: flex"
            @click="savingAdd(2)"
            :class="{on: savingList.indexOf(2) != -1}"
            @mouseup="if (savingList.indexOf(2) == -1) stampYn = true;"
          >
            <span class="ico-checked">checked</span>
            <img src="@/assets/images/user/img_stamp.png" alt="" />
            <span class="txt">{{ $t('User.OrderSaving.msg5') }}</span>
          </div>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--cancel btn-anim" @mouseup="backSaving">{{ $t('User.OrderSaving.msg19') }}</button>
        <button class="btn btn--submit btn-anim" @mouseup="setSaving()">{{ $t('User.OrderSaving.msg20') }}</button>
      </div>
    </div>

    <!-- 멤버쉽 조회 -->
    <MembershipMaster
      v-if="membershipMasterYn"
      @setAlert="setAlert"
      @membersClose="membersClose"
      @setMembersObj="setMembersObj"
      @setPosTransaction="setPosTransaction"
    />

    <!-- 쿠폰 -->
    <Coupon
      v-if="couponDetailYn"
      :totalPrice="baskets.HEADER.SALES_AMT"
      :currUnitText="currUnitText"
      :membersObj="membersObj"
      :posTransaction="posTransaction"
      @nextMembersStep="nextMembersStep"
      @couponClose="couponClose"
    />

    <!-- 멤버쉽 포인트 체크 -->
    <MembershipCheck v-if="membershipCheckYn" :currUnitText="currUnitText" :membersObj="membersObj" @savingPoint="savingPoint" @usePoint="usePoint" />

    <!-- 멤버쉽 포인트 -->
    <MembershipPoint
      v-if="membershipPointYn"
      :currUnitText="currUnitText"
      :membersObj="membersObj"
      :totalPrice="baskets.HEADER.SALES_AMT"
      @cancelPoint="cancelPoint"
      @useMembersPoint="useMembersPoint"
      @setMembersPw="setMembersPw"
    />

    <AlertSuccess v-if="alertSuccessYn" :text="alertText" @setYes="alertSuccessYn = false" />

    <div class="dimed wrap" v-if="membershipErrYn">
      <div class="layer layer--sm">
        <div class="layer__body">
          <div class="ft--xlg ft--bold">{{ $t('User.Membership.msg1') }}</div>
          <div class="ft--xlg ft--bold">{{ $t('User.Membership.msg2') }}</div>
          <div class="ft--lg">{{ membershipErrTxt }}</div>
        </div>
        <div class="layer__button">
          <button class="btn btn--submit btn--xlg" @mouseup="backSaving">
            {{ $t('Modal.AlertConfirm.msg2') }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- //payment__content -->
</template>

<script>
import membershipCheck from '@/components/modal/payment/MembershipCheck.vue';
import membershipPoint from '@/components/modal/payment/MembershipPoint.vue';
import coupon from '@/components/modal/payment/Coupon.vue';
import alertSuccess from '@/components/modal/alert/AlertSuccess.vue';
import membershipMaster from '@/components/modal/payment/MembershipMaster.vue';
import chargeHelper from '@/js/common/chargeHelper.js';

import audioHelper from '@/js/common/audioHelper.js';

import axios from 'axios';

export default {
  name: 'orderSaving',
  props: {
    orderSavingYn: Boolean,
  },
  methods: {
    setPosTransaction(posTransaction) {
      this.posTransaction = posTransaction;
    },
    backSaving() {
      this.membershipErrYn = false;
      chargeHelper.cancleMembership(this.baskets);
      this.$emit('backSaving');
    },
    membersOn() {
      if (this.savingList.indexOf(1) == -1) {
        this.savingList.push(1);
        this.membershipMasterYn = true;
      } else {
        //쿠폰 및 포인트 사용 취소 넣기
        chargeHelper.cancleMembership(this.baskets);
        this.posTransaction = null;
        this.prodUniqueCode = null;
        this.selectCoupon = null;
        this.membersObj = null;
        this.pointSaveYn = false;
        this.point = 0;
        this.savingList.splice(this.savingList.indexOf(1), 1);
        this.membersUseObj = null;
      }
    },
    //멤버쉽 조회 닫기
    membersClose() {
      this.membershipMasterYn = false;
      this.savingList.splice(this.savingList.indexOf(1), 1);
    },
    //쿠폰 닫기
    couponClose() {
      this.couponDetailYn = false;
      if (this.useMembership) this.membershipCheckYn = true;
      else this.savingList.splice(this.savingList.indexOf(1), 1);
    },
    // 경고 알림창
    setAlert(msg) {
      this.alertText = msg;
      this.alertSuccessYn = true;
    },
    // 쿠폰 사용 후 다음 스텝
    nextMembersStep(coupon, item) {
      this.selectCoupon = coupon;
      this.couponDetailYn = false;
      this.prodUniqueCode = item == null ? '' : item.UniqueCode;

      const posConfig = this.$store.getters.getPosConfig.posConfig;
      const couponInfo = {
        TYPE: this.selectCoupon.CouponType,
        DISCOUNT_VALUE: this.selectCoupon.DiscountValue,
        DISCOUNT_TYPE: this.selectCoupon.DiscountType,
        MAX_DISCOUNT_AMOUNT: this.selectCoupon.MaxDiscountAmount,
        PLU_INFO: item,
      };
      chargeHelper.coupon(this.baskets, posConfig, couponInfo, this.posTransaction);

      if (this.useMembership) {
        this.membershipCheckYn = true;
      }
    },
    // 멤버쉽 조회 완료
    setMembersObj(membersObj) {
      this.membersObj = membersObj;
      this.membershipMasterYn = false;
      if (this.useCoupon) {
        this.couponDetailYn = true;
      } else {
        this.membershipCheckYn = true;
      }
    },
    // 멤버쉽 클릭 이벤트
    savingAdd(item) {
      let num = this.savingList.indexOf(item);
      if (num < 0) {
        this.savingList.push(item);
      } else {
        let coupon = this.selectCoupon;
        //금액 할인
        if (coupon.CouponType == 'AMOUNT') {
          if (coupon.DiscountValue >= this.baskets.HEADER.TOT_SALES_AMT) this.baskets.HEADER.TOT_DC_AMT = 0;
          else this.baskets.HEADER.TOT_DC_AMT = this.baskets.HEADER.TOT_DC_AMT - coupon.DiscountValue;
        }
        // % 할인
        else if (coupon.CouponType == 'DISCOUNT') {
          this.baskets.HEADER.TOT_DC_AMT = this.baskets.HEADER.TOT_DC_AMT - this.baskets.HEADER.TOT_SALES_AMT / coupon.DiscountValue;
        }
        // 교환권
        else if (coupon.CouponType == 'EXCHANGE') {
        }
        this.selectCoupon = null;
        this.savingList.splice(num, 1);
      }
    },
    //포인트 적립 alert
    savingPoint() {
      this.membershipCheckYn = false;
      this.alertText = this.$t('User.Membership.msg3');
      this.alertSuccessYn = true;
      this.pointSaveYn = true;
    },
    //포인트 사용화면 이동
    usePoint() {
      this.membershipCheckYn = false;
      this.membershipPointYn = true;
    },
    //포인트 사용 종료
    cancelPoint() {
      this.pointSaveYn = true;
      this.membershipPointYn = false;
      this.alertText = this.$t('User.Membership.msg3');
      this.alertSuccessYn = true;
    },
    //포인트 사용 완료
    useMembersPoint(point) {
      const posConfig = this.$store.getters.getPosConfig.posConfig;
      chargeHelper.membership(this.baskets, posConfig, point);

      this.pointSaveYn = true;
      this.point = point;
      this.membershipPointYn = false;
      this.alertText = this.$t('User.Membership.msg4');
      this.alertSuccessYn = true;
    },
    //멤버쉽 완료
    setSaving() {
      this.$emit('setMembersUseObj', this.membersUseObj);
      this.$logInfo(`Membership Success`);
      this.$store.dispatch('setMembershipApplyYn', true);
      this.$emit('setSaving');
    },
    //멤버쉽 json 만들기
    membershipJsonMake() {
      let membershipJson = {
        pointSave: !this.pointSaveYn
          ? null
          : {
              PointKind: '01',
              CustermerNo: this.membersObj.point.CUST_ID,
              CustermerCardNo: this.membersObj.point.CUST_CARD_NO,
              CustermerPhoneNo: this.membersObj.point.PhoneFullNo,
              CustermerWebID: this.membersObj.point.CUST_WEB_ID,
              CustermerName: this.membersObj.point.CUST_NM,
              CustermerLevel: this.membersObj.point.Level,
              CustermerLevelName: '',
              RemainPoint: this.membersObj.point.TPOINT.toString(),
            },
        pointUse:
          this.point == 0 || !this.useMembership
            ? null
            : {
                Password: this.membershipPw.toString(),
                RequestPoint: Number(this.point),
                MemberNo: this.membersObj.point.CUST_ID,
                PhoneFullNo: this.membersObj.point.PhoneFullNo,
                MembershipCardNo: this.membersObj.point.CUST_CARD_NO,
                AvailablePoint: this.membersObj.point.UPOINT.toString(),
                PwInUse: this.membersObj.point.PwInUse,
                PwUsageCriteriaAmt: this.membersObj.point.PwUsageCriteriaAmt.toString(),
                MininumUnitOfUse: this.membersObj.point.MininumUnitOfUse.toString(),
                UnitOfUse: this.membersObj.point.UnitOfUse.toString(),
                LimitOfUsePoint: this.membersObj.point.LimitOfUsePoint.toString(),
              },
        couponUse:
          this.selectCoupon == null || !this.useCoupon
            ? null
            : {
                //EXCHANGE일때만 PosTransaction.PluInfoList에서 쿠폰 적용할 상품의 UniqueCode값 담아서 보내고, 그 외엔 빈 값
                ProdUniqueCode: this.selectCoupon.CouponType == 'EXCHANGE' ? this.prodUniqueCode : '',
                CouponData: {
                  CouponPublishNo: this.selectCoupon.CouponPublishNo,
                  CouponName: this.selectCoupon.CouponName,
                  MberNo: this.selectCoupon.MberNo,
                  PublishDate: this.selectCoupon.PublishDate,
                  ValidStartDate: this.selectCoupon.ValidStartDate,
                  ValidEndDate: this.selectCoupon.ValidEndDate,
                  Available: this.selectCoupon.Available,
                  CouponType: this.selectCoupon.CouponType,
                  DiscountType: this.selectCoupon.DiscountType,
                  DiscountValue: this.selectCoupon.DiscountValue,
                  MaxDiscountAmount: this.selectCoupon.MaxDiscountAmount,
                },
              },
      };
      return membershipJson;
    },
    setMembersPw(pw) {
      this.membershipPw = pw;
    },
  },
  data() {
    return {
      savingList: [],
      couponYn: false,
      stampYn: false,
      membersObj: null,
      couponDetailYn: false,
      membershipCheckYn: false,
      membershipPointYn: false,
      darkModeYn: this.$store.getters.getDarkModeYn,
      baskets: this.$store.getters.getBaskets,
      currUnitText: this.$store.getters.getCurrUnitText,
      alertSuccessYn: false,
      alertText: '',
      point: 0,
      useMembership: this.$store.getters.getPosConfig.posConfig.supportPayments.indexOf('PAY41') >= 0,
      useCoupon: this.$store.getters.getPosConfig.posConfig.supportPayments.indexOf('PAY47') >= 0,
      useStamp: false,
      membershipMasterYn: false,
      selectCoupon: null,
      prodUniqueCode: '',
      membershipErrYn: false,
      membershipErrTxt: '',
      pointSaveYn: false,
      membershipPw: '',
      membersUseObj: null,
      posTransaction: null,
    };
  },
  mounted() {
    this.$showButtonAnimation();
  },
  updated() {
    this.$showButtonAnimation();
  },
  components: {
    Coupon: coupon,
    MembershipCheck: membershipCheck,
    MembershipPoint: membershipPoint,
    AlertSuccess: alertSuccess,
    MembershipMaster: membershipMaster,
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    remainAmt() {
      return Number(this.point) + 0;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    orderSavingYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          if (!this.$store.getters.getMembershipApplyYn) this.savingList = [];

          audioHelper.playAudio('00109', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    couponYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        //쿠폰 음성으로 변경해야됨
        if (val) {
          audioHelper.playAudio('00110', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/pages/touchbox.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
<style src="@/assets/css/user/dark/touchbox-dark.css" scoped></style>
<style scoped>
.ico-checked {
  display: none;
}

.on > .ico-checked {
  display: block;
}
</style>
